import React from 'react';
import PrintTemplate from "../../../../components/reports/print-reports/print-template.jsx";
import ReportPanel from "./report-panel.jsx";
const Content = ({reportData, data, entity, title, collapsed, printComponentRef, setLoading, setCanPrint, imageLoadRevision}) => {
  return (
    <>
      {
        reportData && data && (
          <PrintTemplate entity={entity} title={title} ref={printComponentRef} setIsPrinting={setLoading}>
            <div id="filters-print" className={'transform !-translate-y-[8.5px]'}></div>
            <div className="print:border-b print:border-gray-200 print:mb-6 print:w-full"/>

            <div className={"w-full mt-[25px] print:mt-[0]"}>
              <ReportPanel data={reportData} setCanPrint={setCanPrint} imageLoadRevision={imageLoadRevision}/>
            </div>
          </PrintTemplate>
        )
      }
    </>
  );
};

export default Content;